/**
 * The note under a registration's fees, wherever they are shown before
 * checkout: the amounts are pre-tax and checkout adds taxes and fees.
 */
export const CHECKOUT_TAXES_AND_FEES_NOTE =
  '* Additional taxes and fees apply at checkout.'
